const API_KEY = '7a706f1cf742e956fdab403f7d8310c31e69eac6dfc78a492ab5f4761a96f256';
// Use apitcg.com which has proper CORS support
const BASE_URL = 'https://www.apitcg.com/api/pokemon';

const headers = {
  'x-api-key': API_KEY,
};

export const searchCards = async (query = '', page = 1, pageSize = 20) => {
  try {
    let url = `${BASE_URL}/cards?page=${page}&limit=${pageSize}`;
    if (query) {
      // Extract name from query like "name:*pikachu*" or just use as name
      const nameMatch = query.match(/name:\*?([^*\s]+)\*?/);
      const name = nameMatch ? nameMatch[1] : query;
      url += `&name=${encodeURIComponent(name)}`;
    }

    const response = await fetch(url, { headers });
    if (!response.ok) {
      throw new Error('Failed to fetch cards');
    }

    const data = await response.json();
    // Map apitcg response to expected format
    return {
      data: data.data || [],
      totalCount: data.total || 0,
      page: data.page || 1,
      pageSize: data.limit || pageSize
    };
  } catch (error) {
    console.error('Error fetching cards:', error);
    throw error;
  }
};

export const getCardById = async (id) => {
  try {
    const response = await fetch(`${BASE_URL}/cards/${id}`, { headers });
    if (!response.ok) {
      throw new Error('Failed to fetch card');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching card:', error);
    throw error;
  }
};

export const getFeaturedCards = async () => {
  try {
    // Fetch popular Pokemon cards for the gallery
    const pokemonNames = ['charizard', 'pikachu', 'mewtwo', 'rayquaza'];

    const cards = [];

    for (const name of pokemonNames) {
      const response = await fetch(
        `${BASE_URL}/cards?name=${name}&limit=1`,
        { headers }
      );

      if (response.ok) {
        const data = await response.json();
        if (data.data && data.data.length > 0) {
          cards.push(data.data[0]);
        }
      }
    }

    return cards;
  } catch (error) {
    console.error('Error fetching featured cards:', error);
    return [];
  }
};

export const getSets = async () => {
  try {
    const response = await fetch(`${BASE_URL}/sets`, { headers });
    if (!response.ok) {
      throw new Error('Failed to fetch sets');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching sets:', error);
    throw error;
  }
};

export const getTypes = async () => {
  // Return common Pokemon types
  return {
    data: ['Colorless', 'Darkness', 'Dragon', 'Fairy', 'Fighting', 'Fire', 'Grass', 'Lightning', 'Metal', 'Psychic', 'Water']
  };
};

export const getRarities = async () => {
  // Return common Pokemon rarities
  return {
    data: ['Common', 'Uncommon', 'Rare', 'Rare Holo', 'Rare Holo EX', 'Rare Holo GX', 'Rare Holo V', 'Rare Holo VMAX', 'Rare Ultra', 'Rare Secret']
  };
};
